import { useTranslation } from 'react-i18next';

export default function PartnershipSection() {
  const { t } = useTranslation('common');

  const partners = [
    {
      type: 'text',
      highlight: true,
    },
    {
      image: 'https://public.readdy.ai/ai/img_res/23e1c3637e43dc5572a97373639df186.jpg',
      type: 'wide',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=modern%20warehouse%20and%20distribution%20center%20in%20sri%20lanka%20with%20organized%20inventory%20and%20logistics%20operations%20clean%20professional%20business%20atmosphere&width=600&height=800&seq=partner-img-001&orientation=portrait',
      type: 'image',
    },
    {
      type: 'text',
    },
    {
      type: 'text',
    },
    {
      type: 'text',
    },
  ];

  return (
    <section id="partnership" className="py-24 bg-[#1f2937]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <i className="ri-links-line text-[#14B8A6] text-base"></i>
            <span className="text-[#14B8A6] text-sm font-medium">{t('partnership.badge')}</span>
          </div>
          <h2 className="text-white text-4xl font-bold mb-4">{t('partnership.title')}</h2>
          <p className="text-gray-400 text-base max-w-2xl mx-auto">
            {t('partnership.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {partners.map((partner, index) => {
            if (partner.type === 'image') {
              return (
                <div
                  key={index}
                  className="relative rounded-3xl overflow-hidden h-96 group cursor-pointer"
                >
                  <div className="w-full h-full">
                    <img
                      src={partner.image}
                      alt={t(`partnership.items.${index}.name`)}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="text-white text-xl font-bold mb-1">{t(`partnership.items.${index}.name`)}</h3>
                    <p className="text-gray-300 text-sm mb-2">{t(`partnership.items.${index}.country`)}</p>
                    <p className="text-gray-300 text-xs leading-relaxed">{t(`partnership.items.${index}.description`)}</p>
                  </div>
                </div>
              );
            }

            if (partner.type === 'wide') {
              return (
                <div
                  key={index}
                  className="relative rounded-3xl overflow-hidden md:col-span-2 h-80 group cursor-pointer"
                >
                  <div className="w-full h-full">
                    <img
                      src={partner.image}
                      alt={t(`partnership.items.${index}.name`)}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-r from-[#14B8A6]/90 via-[#14B8A6]/70 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-8">
                    <h3 className="text-white text-2xl font-bold mb-2">{t(`partnership.items.${index}.name`)}</h3>
                    <p className="text-white/90 text-sm mb-3">{t(`partnership.items.${index}.country`)}</p>
                    <p className="text-white text-sm leading-relaxed max-w-2xl">
                      {t(`partnership.items.${index}.description`)}
                    </p>
                  </div>
                </div>
              );
            }

            return (
              <div
                key={index}
                className={`rounded-3xl p-8 hover:transform hover:scale-105 transition-all duration-300 cursor-pointer ${
                  partner.highlight
                    ? 'bg-gradient-to-br from-[#14B8A6] to-[#0d9488]'
                    : 'bg-[#374151]'
                }`}
              >
                <div className="flex items-center space-x-4 mb-6">
                  <div
                    className={`w-12 h-12 rounded-full flex items-center justify-center ${
                      partner.highlight ? 'bg-white/20' : 'bg-[#14B8A6]'
                    }`}
                  >
                    <span
                      className={`text-lg font-bold ${
                        partner.highlight ? 'text-white' : 'text-white'
                      }`}
                    >
                      {t(`partnership.items.${index}.name`).charAt(0)}
                    </span>
                  </div>
                  <div>
                    <h3
                      className={`text-base font-bold ${
                        partner.highlight ? 'text-white' : 'text-white'
                      }`}
                    >
                      {t(`partnership.items.${index}.name`)}
                    </h3>
                    <p
                      className={`text-xs ${
                        partner.highlight ? 'text-white/80' : 'text-gray-400'
                      }`}
                    >
                      {t(`partnership.items.${index}.country`)}
                    </p>
                  </div>
                </div>

                <div className="mb-4">
                  <i
                    className={`ri-double-quotes-l text-3xl ${
                      partner.highlight ? 'text-white/40' : 'text-[#14B8A6]'
                    }`}
                  ></i>
                </div>

                <p
                  className={`text-sm leading-relaxed ${
                    partner.highlight ? 'text-white' : 'text-gray-300'
                  }`}
                >
                  {t(`partnership.items.${index}.description`)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
